import {
  Component,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { SharedService } from 'src/app/services/shared.service';
import { GlobalContants } from 'src/app/constants/global.contants';
import { filter, map, Subscription } from 'rxjs';
import { UserService } from 'src/app/services/user.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterModule, CommonModule, NgScrollbarModule, TablerIconsModule, MaterialModule],
  templateUrl: './header.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent {
  @Input() showToggle = true;
  @Input() toggleChecked = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleMobileFilterNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();
  userSub$: Subscription = new Subscription();
  userInfo: any;

  GlobalContants = GlobalContants;
  pageTitle:string = '';
  constructor(private sharedService: SharedService,
    private userService: UserService,
    private router: Router,
    private titleService: Title
  ){
   
  }

  ngAfterViewInit(){
   
  }

  ngOnInit(): void {   
    this.pageTitle  = this.titleService.getTitle();
    this.router.events
    .pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => {
        let route: ActivatedRoute = this.router.routerState.root;
        let routeTitle = '';
        while (route!.firstChild) {
          route = route.firstChild;
        }
        if (route.snapshot['title']) {
          routeTitle = route!.snapshot['title'];
        }        
        return routeTitle;
      })
    )
    .subscribe((title: string) => {
      if (title) {
       this.pageTitle = title;
      }
    });
    
    this.userInfo = this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo);
    this.getUserInfo();
  }

  getUserInfo(): void{
    this.userSub$ = this.sharedService.userInfo$.subscribe((res: any) => {
      this.userInfo = this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo);
    });
  }

  logout(){
    this.userService.userLogout();
  }
}